module.exports = __webpack_public_path__ + "media/images/map_nihonbashi_direction2-9294101ebde80a8ffed4864c410c47b7.jpg";